import { NavigationPath } from "./navigation-path";
import Screens from "@/screens";
import { AuthGuard } from "@/auth/AuthGuard";
import { Route } from "@/router/router-types";

export const privateRoutes: Route[] = [
  {
    element: <AuthGuard />,
    children: [
      {
        path: NavigationPath.dashboard,
        element: <Screens.DashBoardView />,
      },
    ],
  },
];
